// AUTO-GENERATED by /app/scripts/convert_to_webp.py — DO NOT EDIT BY HAND.
// Lists every `/assets/...` path that has a real .webp companion on disk.
// SmartImg consults this set so it never emits <source srcSet> for a
// missing file (which would otherwise return the SPA shell HTML and
// silently break the <picture> fallback).
export const WEBP_MANIFEST = new Set([
  "/assets/affiliations/opswa-logo.webp",
  "/assets/anniversary-collage/0a17c8882d17e49d6e8cc0d7f737928387932c25.webp",
  "/assets/anniversary-collage/3a6a29d97022ada592fcd32c41f657e158860e99-1.webp",
  "/assets/anniversary-collage/3be5136df9a35e96de7372cc30bb55cbcfb66d8c.webp",
  "/assets/anniversary-collage/78cbdad42263efd25a73999b6955afe2963c6fdf.webp",
  "/assets/anniversary-collage/b51ac7d4da8eb9ba03bb630a4baf33e3af10e607.webp",
  "/assets/anniversary-collage/b66788d64fb7c3bfd690ba040387cf977ced68e8.webp",
  "/assets/anniversary-collage/c97a29251e347a2a0e71192c67b0a88920614db7.webp",
  "/assets/brand/_legacy-muddy-logo/logo-horizontal-color-new.prior.webp",
  "/assets/brand/_legacy-muddy-logo/logo-horizontal-white-new.cleaned-v1.webp",
  "/assets/brand/_legacy-muddy-logo/logo-horizontal-white-new.cleaned-v2.webp",
  "/assets/brand/_legacy-muddy-logo/logo-horizontal-white-new.cleaned-v3.webp",
  "/assets/brand/_legacy-muddy-logo/logo-horizontal-white-new.webp",
  "/assets/brand/anderson-shield-seal.webp",
  "/assets/brand/hero-graduate.webp",
  "/assets/brand/logo-140years-color.webp",
  "/assets/brand/logo-140years-white.webp",
  "/assets/brand/logo-horizontal-allwhite.webp",
  "/assets/brand/logo-horizontal-color-new.webp",
  "/assets/brand/logo-horizontal-color.webp",
  "/assets/brand/logo-horizontal-color@1x.webp",
  "/assets/brand/logo-horizontal-color@2x.webp",
  "/assets/brand/logo-horizontal-dark.webp",
  "/assets/brand/logo-horizontal-transparent.webp",
  "/assets/brand/logo-horizontal-white-new.webp",
  "/assets/brand/logo-horizontal-white.webp",
  "/assets/brand/logo-horizontal-white@1x.webp",
  "/assets/brand/logo-horizontal-white@2x.webp",
  "/assets/brand/logo-horizontal-white@3x.webp",
  "/assets/brand/logo-stacked-white.webp",
  "/assets/brand/shield-seal.webp",
  "/assets/faculty/aaron-h.webp",
  "/assets/faculty/aarti-l.webp",
  "/assets/faculty/aleksandra-d.webp",
  "/assets/faculty/alina-p.webp",
  "/assets/faculty/alyaa-a-z.webp",
  "/assets/faculty/amarjit-g.webp",
  "/assets/faculty/amber-r.webp",
  "/assets/faculty/ameer-s-b.webp",
  "/assets/faculty/amy-l.webp",
  "/assets/faculty/anahita-m.webp",
  "/assets/faculty/anand-r-2.webp",
  "/assets/faculty/anuradha-t-phd.webp",
  "/assets/faculty/aparna-b.webp",
  "/assets/faculty/april-m.webp",
  "/assets/faculty/audrey-c.webp",
  "/assets/faculty/avery-s.webp",
  "/assets/faculty/bardhyl-v.webp",
  "/assets/faculty/berlindayle-r.webp",
  "/assets/faculty/betiel-n.webp",
  "/assets/faculty/bianca-c.webp",
  "/assets/faculty/boris-v-crsp-p-gsc-ncso.webp",
  "/assets/faculty/brad-m.webp",
  "/assets/faculty/brenda-f.webp",
  "/assets/faculty/camella-d-g.webp",
  "/assets/faculty/carlo-c.webp",
  "/assets/faculty/carol-r.webp",
  "/assets/faculty/carolyn-m.webp",
  "/assets/faculty/cathy-d.webp",
  "/assets/faculty/chantal-n-bsc-msc.webp",
  "/assets/faculty/chantel-s.webp",
  "/assets/faculty/charlie-r.webp",
  "/assets/faculty/charnelle-c.webp",
  "/assets/faculty/cherrie-b.webp",
  "/assets/faculty/cheyenne-m.webp",
  "/assets/faculty/chinju-j.webp",
  "/assets/faculty/christiane-l.webp",
  "/assets/faculty/cleofe-ann-f.webp",
  "/assets/faculty/crystal-t.webp",
  "/assets/faculty/david-s-bsc-hons.webp",
  "/assets/faculty/dean-b.webp",
  "/assets/faculty/deepthi-m-msc-rmlt.webp",
  "/assets/faculty/denise-chih-fang-s-hbsc.webp",
  "/assets/faculty/dhilal-a-h.webp",
  "/assets/faculty/diana-g.webp",
  "/assets/faculty/dina-m.webp",
  "/assets/faculty/donna-c.webp",
  "/assets/faculty/dora-w.webp",
  "/assets/faculty/edelnario-jr-g.webp",
  "/assets/faculty/edith-l.webp",
  "/assets/faculty/edward-g-2.webp",
  "/assets/faculty/elma-b.webp",
  "/assets/faculty/eman-q.webp",
  "/assets/faculty/emily-b.webp",
  "/assets/faculty/emmylous-f.webp",
  "/assets/faculty/eric-s.webp",
  "/assets/faculty/evelyn-r.webp",
  "/assets/faculty/farhana-k.webp",
  "/assets/faculty/farzana-a.webp",
  "/assets/faculty/fazal-m.webp",
  "/assets/faculty/felix-r.webp",
  "/assets/faculty/fely-grace-p-bscn.webp",
  "/assets/faculty/ferdinand-e.webp",
  "/assets/faculty/ferdinand-p.webp",
  "/assets/faculty/flavio-b.webp",
  "/assets/faculty/folakemi-t-i.webp",
  "/assets/faculty/francine-a.webp",
  "/assets/faculty/frank-kwa-mlt-hbsc.webp",
  "/assets/faculty/gayane-o.webp",
  "/assets/faculty/gayathri-n.webp",
  "/assets/faculty/genelyn-f.webp",
  "/assets/faculty/gloria-m.webp",
  "/assets/faculty/hamsha-m-bscn-hbsc.webp",
  "/assets/faculty/harpreet-j.webp",
  "/assets/faculty/heather-p-bed-med.webp",
  "/assets/faculty/helen-l-bsc-mlt.webp",
  "/assets/faculty/ilia-m.webp",
  "/assets/faculty/ilona-r.webp",
  "/assets/faculty/irene-p.webp",
  "/assets/faculty/iryna-m.webp",
  "/assets/faculty/isaac-j.webp",
  "/assets/faculty/jackie-s.webp",
  "/assets/faculty/jacqueline-h.webp",
  "/assets/faculty/jagdeep-b-2.webp",
  "/assets/faculty/jaleyen-r.webp",
  "/assets/faculty/janet-d.webp",
  "/assets/faculty/jeet-b.webp",
  "/assets/faculty/jemella-c.webp",
  "/assets/faculty/jennifer-m-bsc-crgs.webp",
  "/assets/faculty/jessica-i.webp",
  "/assets/faculty/john-l-2.webp",
  "/assets/faculty/john-p-j-m.webp",
  "/assets/faculty/johnny-c-bsc-msc.webp",
  "/assets/faculty/jolene-b.webp",
  "/assets/faculty/judy-g.webp",
  "/assets/faculty/julia-b.webp",
  "/assets/faculty/karan-c.webp",
  "/assets/faculty/karen-c.webp",
  "/assets/faculty/kathy-m.webp",
  "/assets/faculty/katrina-f.webp",
  "/assets/faculty/kelly-h.webp",
  "/assets/faculty/kimberley-m.webp",
  "/assets/faculty/lani-p-bscn-ma.webp",
  "/assets/faculty/laureen-d.webp",
  "/assets/faculty/laurie-k.webp",
  "/assets/faculty/leena-n.webp",
  "/assets/faculty/lina-l-r.webp",
  "/assets/faculty/lindsey-b.webp",
  "/assets/faculty/lindy-m.webp",
  "/assets/faculty/liz-p.webp",
  "/assets/faculty/lizaren-j.webp",
  "/assets/faculty/lori-a.webp",
  "/assets/faculty/lucie-p.webp",
  "/assets/faculty/lucy-b.webp",
  "/assets/faculty/maha-h.webp",
  "/assets/faculty/maham-s.webp",
  "/assets/faculty/manal-a.webp",
  "/assets/faculty/manjot-k.webp",
  "/assets/faculty/marcie-p.webp",
  "/assets/faculty/maria-karla-d-m.webp",
  "/assets/faculty/maria-sonia-p.webp",
  "/assets/faculty/marlon-a.webp",
  "/assets/faculty/mary-g-v.webp",
  "/assets/faculty/mary-h-2.webp",
  "/assets/faculty/maryna-b.webp",
  "/assets/faculty/mati-m-2.webp",
  "/assets/faculty/mechille-s-ba.webp",
  "/assets/faculty/meena-s.webp",
  "/assets/faculty/melchora-r.webp",
  "/assets/faculty/melissa-g.webp",
  "/assets/faculty/melissa-p.webp",
  "/assets/faculty/michelle-b.webp",
  "/assets/faculty/michelle-s.webp",
  "/assets/faculty/najia-m.webp",
  "/assets/faculty/naseem-f-ba.webp",
  "/assets/faculty/neda-j.webp",
  "/assets/faculty/neha-p-s.webp",
  "/assets/faculty/nerisa-a.webp",
  "/assets/faculty/nicole-l.webp",
  "/assets/faculty/nika-v.webp",
  "/assets/faculty/nikki-c.webp",
  "/assets/faculty/nimarjeet-k.webp",
  "/assets/faculty/nithya-e.webp",
  "/assets/faculty/orlando-b-2.webp",
  "/assets/faculty/perry-b.webp",
  "/assets/faculty/pooja-v-mpt.webp",
  "/assets/faculty/prikita-s-2.webp",
  "/assets/faculty/priyanka-s.webp",
  "/assets/faculty/rafik-ragheb.webp",
  "/assets/faculty/rahim-m.webp",
  "/assets/faculty/ram-s.webp",
  "/assets/faculty/ramandeep-s.webp",
  "/assets/faculty/rani-h.webp",
  "/assets/faculty/rashmeet-b.webp",
  "/assets/faculty/rhonda-e.webp",
  "/assets/faculty/roderick-m.webp",
  "/assets/faculty/rosalina-v-2.webp",
  "/assets/faculty/ruena-h.webp",
  "/assets/faculty/safire-d.webp",
  "/assets/faculty/safraz-a-md.webp",
  "/assets/faculty/salima-h-s-bsc.webp",
  "/assets/faculty/samantha-s.webp",
  "/assets/faculty/samiha-t-j.webp",
  "/assets/faculty/sarah-s.webp",
  "/assets/faculty/shabnam-b.webp",
  "/assets/faculty/shaeba-r.webp",
  "/assets/faculty/sharee-m-2.webp",
  "/assets/faculty/shelly-ann-h.webp",
  "/assets/faculty/shweta-a-ba-msc.webp",
  "/assets/faculty/silvie-e.webp",
  "/assets/faculty/sonu-p.webp",
  "/assets/faculty/stefania-l.webp",
  "/assets/faculty/sudine-r.webp",
  "/assets/faculty/sue-ann-m.webp",
  "/assets/faculty/sweta-p.webp",
  "/assets/faculty/syeda-r.webp",
  "/assets/faculty/sylvia-t.webp",
  "/assets/faculty/tammy-f.webp",
  "/assets/faculty/taylor-m.webp",
  "/assets/faculty/thomas-e.webp",
  "/assets/faculty/tim-w-2.webp",
  "/assets/faculty/tonmoy-p.webp",
  "/assets/faculty/tony-a-bsc-msc.webp",
  "/assets/faculty/tovah-l.webp",
  "/assets/faculty/tracey-d.webp",
  "/assets/faculty/vicki-g.webp",
  "/assets/faculty/victora-c.webp",
  "/assets/faculty/victoria-a.webp",
  "/assets/faculty/victoria-g-h-3.webp",
  "/assets/faculty/viqar-k.webp",
  "/assets/faculty/vycki-r.webp",
  "/assets/faculty/wanda-s.webp",
  "/assets/faculty/winnie-l.webp",
  "/assets/faculty/yodeet-l.webp",
  "/assets/faculty/youvika-m.webp",
  "/assets/faculty/zani-d.webp",
  "/assets/faculty/zeynab-a.webp",
  "/assets/heroes/admissions-international-hero.webp",
  "/assets/heroes/alumni-bursary-hero-mobile.webp",
  "/assets/heroes/alumni-bursary-hero.webp",
  "/assets/heroes/anniversary-hero-mobile.webp",
  "/assets/heroes/anniversary-hero.webp",
  "/assets/heroes/better-jobs-ontario-hero-mobile.webp",
  "/assets/heroes/better-jobs-ontario-hero.webp",
  "/assets/heroes/cardiology-bursary-hero.webp",
  "/assets/heroes/career-services-hero-mobile.webp",
  "/assets/heroes/career-services-hero.webp",
  "/assets/heroes/contact-hero-mobile.webp",
  "/assets/heroes/contact-hero.webp",
  "/assets/heroes/digital-credentials-hero-mobile.webp",
  "/assets/heroes/digital-credentials-hero.webp",
  "/assets/heroes/empower-ukrainians-hero.webp",
  "/assets/heroes/faculty-hero.webp",
  "/assets/heroes/financial-aid-hero-mobile.webp",
  "/assets/heroes/financial-aid-hero.webp",
  "/assets/heroes/gmssp-hero-mobile.webp",
  "/assets/heroes/gmssp-hero.webp",
  "/assets/heroes/how-to-apply-hero.webp",
  "/assets/heroes/land-acknowledgements-hero-mobile.webp",
  "/assets/heroes/land-acknowledgements-hero.webp",
  "/assets/heroes/need-help-hero-mobile.webp",
  "/assets/heroes/need-help-hero.webp",
  "/assets/heroes/new-to-canada-hero-mobile.webp",
  "/assets/heroes/new-to-canada-hero.webp",
  "/assets/heroes/odaa-hero.webp",
  "/assets/heroes/opswa-hero.webp",
  "/assets/heroes/out-of-province-students-hero-mobile.webp",
  "/assets/heroes/out-of-province-students-hero.webp",
  "/assets/heroes/press-corner-hero-mobile.webp",
  "/assets/heroes/press-corner-hero.webp",
  "/assets/heroes/resources-hero.webp",
  "/assets/heroes/student-lines-of-credit-hero-mobile.webp",
  "/assets/heroes/student-lines-of-credit-hero.webp",
  "/assets/heroes/testimonials-hero-mobile.webp",
  "/assets/heroes/testimonials-hero.webp",
  "/assets/heroes/why-anderson-hero-mobile.webp",
  "/assets/heroes/why-anderson-hero.webp",
  "/assets/heroes/windmill-microlending-hero-mobile.webp",
  "/assets/heroes/windmill-microlending-hero.webp",
  "/assets/heroes/work-at-anderson-hero-mobile.webp",
  "/assets/heroes/work-at-anderson-hero.webp",
  "/assets/home/hero-desktop.webp",
  "/assets/home/hero-mobile.webp",
  "/assets/home/testimonial-Aleah.webp",
  "/assets/icons/gmssp/image-14.webp",
  "/assets/icons/gmssp/image-15.webp",
  "/assets/icons/gmssp/image-16.webp",
  "/assets/icons/gmssp/image-17.webp",
  "/assets/icons/gmssp/image-18.webp",
  "/assets/icons/gmssp/image-19.webp",
  "/assets/icons/resources/Frame-2121453707.webp",
  "/assets/icons/resources/Layer_1-1.webp",
  "/assets/icons/resources/Layer_1.webp",
  "/assets/icons/resources/indicator-1.webp",
  "/assets/logo-shield-white.webp",
  "/assets/mascot/husky.webp",
  "/assets/migrated/018fc5dee2-career-blog-Banner.webp",
  "/assets/migrated/0391305d11-James.webp",
  "/assets/migrated/0577c2f653-Chantel-Bio-photo-300x200.webp",
  "/assets/migrated/0640386fbe-Aayushi-Patel.webp",
  "/assets/migrated/06d4539d43-Brad-Murray-bio-e1706817884542-300x200.webp",
  "/assets/migrated/06ffbd5f40-connect-blog-Banner.webp",
  "/assets/migrated/0709541d1d-Golden-Gavel-Group-Photo-1024x587-1.webp",
  "/assets/migrated/07c081f6f1-Karla-MLAT-blog-Banner.webp",
  "/assets/migrated/07d3124652-Rosalina-V-300x211.webp",
  "/assets/migrated/08a3ab89b0-Janette-A.webp",
  "/assets/migrated/08bb9c9ce4-Frame-2121453689.webp",
  "/assets/migrated/0b508b323a-Mariam-Thomas.webp",
  "/assets/migrated/0b8fd10af6-2025.webp",
  "/assets/migrated/0e08ad9f47-Akshatha-H.webp",
  "/assets/migrated/0e430a7c8e-BMO.webp",
  "/assets/migrated/0f27959675-Samuel-blog-Banner.webp",
  "/assets/migrated/0fa2cf7ab4-Me-in-Andersen-College.-e1674223415938-225x300-1.webp",
  "/assets/migrated/0fbdb235c8-ME-blog-Banner.webp",
  "/assets/migrated/11fc61fbe2-Jimmy-Thomas-scaled-e1772470379360.webp",
  "/assets/migrated/12239a6865-Rebeca-Jaimes-scaled.webp",
  "/assets/migrated/12746b452c-pharma-blog-Banner.webp",
  "/assets/migrated/12e74ef265-Victoria-A-251x300.webp",
  "/assets/migrated/1319647bf9-Nawar-Asbar.webp",
  "/assets/migrated/1432c3fac4-PSW-blog-Banner.webp",
  "/assets/migrated/14d923bc78-adrianne-blog-Banner-1.webp",
  "/assets/migrated/15443d32c3-construction-blog-Banner.webp",
  "/assets/migrated/1800c4555b-CT-blog-Banner.webp",
  "/assets/migrated/1b6649a7db-Malak-Bakhash.webp",
  "/assets/migrated/1b944d2d3d-Alireza-A.webp",
  "/assets/migrated/1d1b3ee14f-Rupinder-Kaur.webp",
  "/assets/migrated/1dcfa45fac-Anahita-bio-300x200.webp",
  "/assets/migrated/1dd95d7e49-Frame-10-1.webp",
  "/assets/migrated/2113f93172-Anna-Garmatyuk.webp",
  "/assets/migrated/21e3a3b1a9-Samantha-D-D-e1714057710616.webp",
  "/assets/migrated/23a60b5c92-Ram-Bio-photo-300x200.webp",
  "/assets/migrated/265e766b33-Micheline-T.webp",
  "/assets/migrated/274c7d792d-speech-icon-1.webp",
  "/assets/migrated/28b8727865-Kiana-Jones.webp",
  "/assets/migrated/29be436ee9-HM6-1024x821.webp",
  "/assets/migrated/2a5ff967b8-2020.webp",
  "/assets/migrated/2b4707eb61-Marck-blog-Banner.webp",
  "/assets/migrated/2b921b5566-Shweta-A-300x211.webp",
  "/assets/migrated/2b9ad865cd-Wanda-Bio-photo-300x200.webp",
  "/assets/migrated/2ba6ce9d70-Aleksandra-Delic_ccexpress-189x300.webp",
  "/assets/migrated/2bef3e0f7e-Cleoffe-Ann-F-Bio-photo-300x200.webp",
  "/assets/migrated/2c6649c96c-SCL-blog-Banner.webp",
  "/assets/migrated/2ca2848cd9-Picture1-1.webp",
  "/assets/migrated/2d73314074-charlie-bio-300x200.webp",
  "/assets/migrated/2fa15dcba9-Ella-Johnson.webp",
  "/assets/migrated/301e18e8ed-Austin-Mailloux.webp",
  "/assets/migrated/3245b0fdcb-DMS-blog-Banner.webp",
  "/assets/migrated/3390ec2d7f-Amy.webp",
  "/assets/migrated/33cbc9b1ec-connect-blog-Banner.webp",
  "/assets/migrated/36db494293-Cover-Letter-Importance-blog-Banner.webp",
  "/assets/migrated/36f740eec3-Evelyn-demalata.webp",
  "/assets/migrated/3806073e61-William-blog-Banner.webp",
  "/assets/migrated/399bf43a25-Layth-Al-Mafrachi.webp",
  "/assets/migrated/3a580cc4cd-Marina-G-e1689953686364.webp",
  "/assets/migrated/3b8c88819b-Alex-blog-Banner.webp",
  "/assets/migrated/3dc6845ac7-OHS-blog-Banner.webp",
  "/assets/migrated/424faf9f9c-RBC.webp",
  "/assets/migrated/43a0e81a23-construction-blog-Banner-1.webp",
  "/assets/migrated/44dd1a3526-Rectangle-4663-1.webp",
  "/assets/migrated/45363448e6-Mary-Hogeterp-Bio-photo-300x200.webp",
  "/assets/migrated/464a536c60-Nika-Bio-photo-300x200.webp",
  "/assets/migrated/48d412fd25-Katherine-Torell-1.webp",
  "/assets/migrated/4a389eacdc-Emelyn-Quinto.webp",
  "/assets/migrated/4b7edf9f09-Alexa-blog-Banner2-300x200.webp",
  "/assets/migrated/4c65fa772d-Ionha-Crosby.webp",
  "/assets/migrated/4ce560474e-Marina-G.webp",
  "/assets/migrated/4f40380832-Rebecca-Beaudoin.webp",
  "/assets/migrated/4f844bd420-Rectangle-4660-1-1.webp",
  "/assets/migrated/4fc8cf10ee-Eric-Ng.webp",
  "/assets/migrated/50128249b8-IMG_2524-scaled.webp",
  "/assets/migrated/50375d3971-finance-phone-icon-2-1.webp",
  "/assets/migrated/538796d476-TD.webp",
  "/assets/migrated/54b4f33fe8-IODA-blog-Banner.webp",
  "/assets/migrated/550e1a5e59-SC.webp",
  "/assets/migrated/553566eafc-Christine-PSW-blog-Banner.webp",
  "/assets/migrated/58646c774c-Amir-Alemohamnad.webp",
  "/assets/migrated/58b73f4211-paralegal-blog-Banner.webp",
  "/assets/migrated/58cffe3665-Rectangle-4658-2-1-1.webp",
  "/assets/migrated/58ff77273c-Ivy2-blog-Banner.webp",
  "/assets/migrated/59001cdb9d-Amber-Bio-photo-300x200.webp",
  "/assets/migrated/5d5706dbc0-Curtis-Bolton-1.webp",
  "/assets/migrated/5f5e7ed0c8-protect-ontario-PSW-blog-Banner.webp",
  "/assets/migrated/616b93ee4e-Paula-bianca-M.webp",
  "/assets/migrated/61fa625897-SCL-blog-Banner-e1769452445146.webp",
  "/assets/migrated/6204b613a4-ilia-Bio-photo-300x200.webp",
  "/assets/migrated/6261952385-aparna-bio-e1703088564603-300x200.webp",
  "/assets/migrated/628972c88b-Puneet2-blog-Banner.webp",
  "/assets/migrated/62b7b59d32-Mohammad-Iqbal-Sapand-1.webp",
  "/assets/migrated/62e9d7e34b-Jianjie-Copy.webp",
  "/assets/migrated/63962e37ae-Maria-Solange-Picard.webp",
  "/assets/migrated/63c6478d8f-Nikita-Sharma.webp",
  "/assets/migrated/65f1308931-Kimberley-Bio-photo-300x200.webp",
  "/assets/migrated/662dbdb981-Masoud-Salimian.webp",
  "/assets/migrated/6656f8efe3-BA-blog-Banner.webp",
  "/assets/migrated/6680d6e16d-Clarissa-M.webp",
  "/assets/migrated/67652d9778-Sandra-F-scaled.webp",
  "/assets/migrated/6977978d0d-Helena-B.webp",
  "/assets/migrated/69b3c58b33-Rectangle-4654-1-1.webp",
  "/assets/migrated/6b9ea145da-Chijioke-Victor-Aguocha.webp",
  "/assets/migrated/6d0b10d9d7-MLAT-blog-Banner.webp",
  "/assets/migrated/6d3f4a1634-shabir-ahmad-Hamid.webp",
  "/assets/migrated/6d6270969d-Clothing-Closet-1.webp",
  "/assets/migrated/6ebf403426-IT-blog-Banner.webp",
  "/assets/migrated/6efc589919-Picture1-300x202-1.webp",
  "/assets/migrated/704a1754ef-Abigail-e1714057665853.webp",
  "/assets/migrated/70fdde0363-Holly.webp",
  "/assets/migrated/71b72af46e-Gohar-Grigoryan.webp",
  "/assets/migrated/737f9e36d8-Alexa-blog-Banner.webp",
  "/assets/migrated/753c0fe3a9-Yalmozhi-Maragathavelu.webp",
  "/assets/migrated/75feaa427a-Janet-E.webp",
  "/assets/migrated/7601542921-Rectangle-4653-1-1.webp",
  "/assets/migrated/765d50aab6-Ivy-blog-Banner.webp",
  "/assets/migrated/77c153b0d6-Julia-bio-300x200.webp",
  "/assets/migrated/7b97501ebb-Lizaren-J-300x211.webp",
  "/assets/migrated/7df609392d-20250109_085601072-1024x768.webp",
  "/assets/migrated/7f68f54ab8-Career-blog-Banner.webp",
  "/assets/migrated/7fda64fdc6-Deepika-LNU.webp",
  "/assets/migrated/823f1080ac-rabia-n.webp",
  "/assets/migrated/8500bf49cd-start-dates-IODA.webp",
  "/assets/migrated/8619853ff5-Rawan-Al-Bawab.webp",
  "/assets/migrated/87235d2920-Kriska-A-scaled-e1689953757546.webp",
  "/assets/migrated/873caecafb-Corinne-Beaulieu.webp",
  "/assets/migrated/8745c01bc9-Andrew-V.webp",
  "/assets/migrated/883fae2fa8-Eldenario-Bio-photo-300x200.webp",
  "/assets/migrated/8a390be9b3-Beenash-Firdous.webp",
  "/assets/migrated/8c717e6c31-Aida-blog-Banner.webp",
  "/assets/migrated/8e2572af82-HIM-blog-Banner.webp",
  "/assets/migrated/8e3d66bdde-Thanh2-blog-Banner.webp",
  "/assets/migrated/90a88f82f5-Melissa-Price-scaled-1-225x300.webp",
  "/assets/migrated/912e2891f4-Harsimran-Sandhu.webp",
  "/assets/migrated/918a59ade6-Picture1-300x211-1.webp",
  "/assets/migrated/91a804b1de-Picture2.webp",
  "/assets/migrated/92d0d2d764-Jamie-Rumford.webp",
  "/assets/migrated/931709ae5f-Amrita-blog-Banner.webp",
  "/assets/migrated/947fcb91fa-Cibc.webp",
  "/assets/migrated/952e9a2961-Rahim-bio-300x200.webp",
  "/assets/migrated/9592e656cd-prikita-bio-e1701804483683-300x200.webp",
  "/assets/migrated/95e89da7b6-Manal-Ameen.webp",
  "/assets/migrated/95ec7ef7ef-Vicky-Vuong-Photo.webp",
  "/assets/migrated/9e6ad14d2b-Delse-P-1.webp",
  "/assets/migrated/9f828c8acb-Owen-James-Bautista-1.webp",
  "/assets/migrated/a2ef33acd7-Pearl-Samillano.webp",
  "/assets/migrated/a2f1fdd826-Amanda-Roberts.webp",
  "/assets/migrated/a332fab3bb-Sylvia-Bio-photo-300x200.webp",
  "/assets/migrated/a38a48f53d-Kalpana-Weeraratne-1.webp",
  "/assets/migrated/a477d0e6e6-Rajni-Chohan.webp",
  "/assets/migrated/a4dda6f01a-Group-48096137.webp",
  "/assets/migrated/a4fdeeb4bb-Rectangle-15.webp",
  "/assets/migrated/a61d842f60-perry-bio-e1703088104834-300x200.webp",
  "/assets/migrated/a67dac5df2-Rectangle-4655-1-1.webp",
  "/assets/migrated/a75fb86f42-Stefania-L-bio-300x200.webp",
  "/assets/migrated/a7f76665bd-COMING-SOON-MAN-300x169.webp",
  "/assets/migrated/a86351e5be-SHAREE-MANDEL-FACULTY-300x211.webp",
  "/assets/migrated/a9d3074657-lightbulb-icon-2-1.webp",
  "/assets/migrated/ab4ecca076-Jemella-Bio-photo-300x200.webp",
  "/assets/migrated/abbfdd829e-Salima-Suleman-Headshot-300x211.webp",
  "/assets/migrated/afad491ab9-Christine-day.webp",
  "/assets/migrated/b47a99f1db-Dora-Bio-photo-300x200.webp",
  "/assets/migrated/b4eb895b69-Frame-2121453694.webp",
  "/assets/migrated/b629ab05a2-Rectangle-4662-1-1.webp",
  "/assets/migrated/b86fb006f8-1885.webp",
  "/assets/migrated/b944c23e9f-Helya-Azizmohammadi.webp",
  "/assets/migrated/b9921023e1-Kelly-Bio-photo-300x200.webp",
  "/assets/migrated/bb63fb06ec-Sonu-Bio-photo.webp",
  "/assets/migrated/bcc24a0a93-Baby-Rose-V.webp",
  "/assets/migrated/bd03bf3860-Haylie-Eady.webp",
  "/assets/migrated/c0e39e8c61-Jose-Fausto.webp",
  "/assets/migrated/c2c091e847-Rectangle-4656-1-1.webp",
  "/assets/migrated/c37e32b1c5-Rectangle-4652-1.webp",
  "/assets/migrated/c45139e616-Janette-H-e1714057749812.webp",
  "/assets/migrated/c4a421eb04-Tanya-Perch-1.webp",
  "/assets/migrated/c6c7f4e97d-Shahrzhad-blog-Banner.webp",
  "/assets/migrated/c6c8068a61-flower.webp",
  "/assets/migrated/c7764a744d-ME-blog-Banner.webp",
  "/assets/migrated/c7fffd2944-Karla-MLAT2-blog-Banner.webp",
  "/assets/migrated/c8d1bb622c-Maryam-Rizvi.webp",
  "/assets/migrated/cad9e33d48-2022.webp",
  "/assets/migrated/cb4ab1da09-john-l-300x211.webp",
  "/assets/migrated/cf2f65ea55-anderson-protect-ontario-blog-Banner.webp",
  "/assets/migrated/cf36621da6-0a17c8882d17e49d6e8cc0d7f737928387932c25-rg6wls7azqfl44x78fh.webp",
  "/assets/migrated/cf3d2d23e4-Jakob-blog-Banner.webp",
  "/assets/migrated/d0aa24623f-SCL-blog-Banner.webp",
  "/assets/migrated/d0cbb44841-CYC-blog-Banner-1.webp",
  "/assets/migrated/d19f3b9340-Amna-Ali.webp",
  "/assets/migrated/d2deb3af52-Beenash-blog-Banner-1.webp",
  "/assets/migrated/d3418f473c-Jessica-B.webp",
  "/assets/migrated/d4b5290f44-Erica-Dangelo.webp",
  "/assets/migrated/d5029c4c81-11C808DE-38C9-444B-B9F4-A86689A2A35.webp",
  "/assets/migrated/d881a8b256-Bruce-blog-Banner.webp",
  "/assets/migrated/d99ebb6258-top-careers-blog-Banner.webp",
  "/assets/migrated/da56fc45df-Remedios-e1689953802771.webp",
  "/assets/migrated/dad6a0319d-Thushyanthy-p.webp",
  "/assets/migrated/db21ef9786-Samiha-Bio-photo-300x200.webp",
  "/assets/migrated/dda10e4903-IT-blog-Banner.webp",
  "/assets/migrated/ddafc4c63f-MLAT-blog-Banner.webp",
  "/assets/migrated/ddc5eb270b-Adriana-Shaw.webp",
  "/assets/migrated/de34586c86-woman-icon-2-1.webp",
  "/assets/migrated/e0553d36c2-IODA-blog-Banner.webp",
  "/assets/migrated/e0e8a5acd4-Sarah-Bio-photo-300x200.webp",
  "/assets/migrated/e106e1058f-Alex-MLAT-blog-Banner.webp",
  "/assets/migrated/e13f809762-azar-zargaran.webp",
  "/assets/migrated/e3f4fb543c-Sweta-P-bio-e1706884432550-300x200.webp",
  "/assets/migrated/e40a1b65ee-Jawariya-Umair.webp",
  "/assets/migrated/e475b51b88-0015_CCA2023LONDON_HRM-e1675437764912.webp",
  "/assets/migrated/e47e2dd557-ECE-blog-Banner.webp",
  "/assets/migrated/e7ad165fb0-Olasile-Oduwole.webp",
  "/assets/migrated/e8b470672d-mylene-v.webp",
  "/assets/migrated/e8b9b82cd8-Dilpuneet-Shah.webp",
  "/assets/migrated/e90ba901e1-OHS-blog-Banner-1.webp",
  "/assets/migrated/e93a4f8981-IMG-20251207-WA0003-1024x768.webp",
  "/assets/migrated/e9de6f45d4-APA-blog-Banner.webp",
  "/assets/migrated/eb36ebdc6e-Safraz-A-300x211.webp",
  "/assets/migrated/ed029fe6f0-connect-blog-Banner.webp",
  "/assets/migrated/ee98b70cc3-Johnny-C-300x211.webp",
  "/assets/migrated/ef72a9f29f-Clothing-Closet-4-Patricia-scaled.webp",
  "/assets/migrated/f01e459c34-profile-image-e1692038856429.webp",
  "/assets/migrated/f2a8e01198-Heherson-S-1.webp",
  "/assets/migrated/f31c12904a-IODA-blog-Banner-1.webp",
  "/assets/migrated/f616b334d4-Heherson-S-scaled.webp",
  "/assets/migrated/f6447e9150-2011.webp",
  "/assets/migrated/f65e59e9a5-Alexa-blog-Banner2.webp",
  "/assets/migrated/f7d19fc642-Rafik-R.-scaled-e1651502442675.webp",
  "/assets/migrated/f896c67007-MOA-blog-Banner.webp",
  "/assets/migrated/fa64a82b2c-Katrina-M-1.webp",
  "/assets/migrated/fb5399a7e1-Joycelyn-S.webp",
  "/assets/migrated/fbe40f0a43-connect-blog-Banner.webp",
  "/assets/migrated/fc19d79adf-Alireza-A.webp",
  "/assets/migrated/fd3e166ae3-Pallavi-Upadhye.webp",
  "/assets/migrated/fe5c638840-Sahil-Mogla.webp",
  "/assets/migrated/ff449ee50e-Brooke-O.webp",
  "/assets/migrated/fff1babb43-Aira-O.webp",
  "/assets/migrated/odaa-logo2.webp",
  "/assets/partners/campus-bookstore-logo.webp",
  "/assets/programs/ba/blog-Maia-path.webp",
  "/assets/programs/ba/blog-subjects.webp",
  "/assets/programs/ba/blog-what-is-ba.webp",
  "/assets/programs/ba/faculty-Amarjit.webp",
  "/assets/programs/ba/faculty-Dean.webp",
  "/assets/programs/ba/faculty-Flavio.webp",
  "/assets/programs/ba/faculty-Maryna.webp",
  "/assets/programs/ba/faculty-Meena.webp",
  "/assets/programs/ba/review-Apurva.webp",
  "/assets/programs/ba/review-Maia.webp",
  "/assets/programs/ba/review-Praise.webp",
  "/assets/programs/ba/review-Rodessa.webp",
  "/assets/programs/batch2/hero-apa.webp",
  "/assets/programs/batch2/hero-bg1.webp",
  "/assets/programs/batch2/hero-bg2.webp",
  "/assets/programs/batch2/hero-bg4.webp",
  "/assets/programs/batch2/hero-bg6.webp",
  "/assets/programs/batch2/hero-bg7.webp",
  "/assets/programs/batch2/hero-cardiology.webp",
  "/assets/programs/batch2/hero-cycasw.webp",
  "/assets/programs/batch2/hero-dental.webp",
  "/assets/programs/batch2/hero-dentrad.webp",
  "/assets/programs/batch2/hero-dms.webp",
  "/assets/programs/batch2/hero-eca.webp",
  "/assets/programs/batch2/hero-ece.webp",
  "/assets/programs/batch2/hero-esthetician.webp",
  "/assets/programs/batch2/hero-him.webp",
  "/assets/programs/batch2/hero-it.webp",
  "/assets/programs/batch2/hero-law.webp",
  "/assets/programs/batch2/hero-mla-bridging.webp",
  "/assets/programs/batch2/hero-mlt.webp",
  "/assets/programs/batch2/hero-ohs.webp",
  "/assets/programs/batch2/hero-ortho.webp",
  "/assets/programs/batch2/hero-paralegal.webp",
  "/assets/programs/batch2/hero-pharmacy.webp",
  "/assets/programs/batch2/hero-pharmasst.webp",
  "/assets/programs/batch2/hero-pta.webp",
  "/assets/programs/batch2/hero-supply.webp",
  "/assets/programs/mla/blog-Alex.webp",
  "/assets/programs/mla/blog-Beenash.webp",
  "/assets/programs/mla/blog-employers.webp",
  "/assets/programs/mla/faculty-Ameer.webp",
  "/assets/programs/mla/faculty-Bardhyl.webp",
  "/assets/programs/mla/faculty-Berlindayle.webp",
  "/assets/programs/mla/faculty-Bianca.webp",
  "/assets/programs/mla/faculty-Charlie.webp",
  "/assets/programs/mla/faculty-Cherrie.webp",
  "/assets/programs/mla/faculty-Deepthi.webp",
  "/assets/programs/mla/faculty-Emmylous.webp",
  "/assets/programs/mla/faculty-Evelyn.webp",
  "/assets/programs/mla/faculty-Ferdinand.webp",
  "/assets/programs/mla/faculty-Helen.webp",
  "/assets/programs/mla/faculty-Jessica.webp",
  "/assets/programs/mla/faculty-Maria-Karla.webp",
  "/assets/programs/mla/faculty-Mary.webp",
  "/assets/programs/mla/faculty-Melchora.webp",
  "/assets/programs/mla/faculty-Najia.webp",
  "/assets/programs/mla/faculty-Naseem.webp",
  "/assets/programs/mla/faculty-Orlando.webp",
  "/assets/programs/mla/faculty-Rafik.webp",
  "/assets/programs/mla/faculty-Tammy.webp",
  "/assets/programs/mla/faculty-Tonmoy.webp",
  "/assets/programs/mla/hero-medical-workers.webp",
  "/assets/programs/mla/hero-mlat-staging.webp",
  "/assets/programs/mla/review-Aayushi.webp",
  "/assets/programs/mla/review-Beenash.webp",
  "/assets/programs/mla/review-Pearl.webp",
  "/assets/programs/mla/review-Rebecca.webp",
  "/assets/programs/moa/carol.webp",
  "/assets/programs/moa/dina.webp",
  "/assets/programs/moa/emily.webp",
  "/assets/programs/moa/hero-Background-2.webp",
  "/assets/programs/moa/hero-hospital.webp",
  "/assets/programs/moa/ilona.webp",
  "/assets/programs/moa/katrina.webp",
  "/assets/programs/moa/leena.webp",
  "/assets/programs/moa/marion.webp",
  "/assets/programs/moa/mechille.webp",
  "/assets/programs/moa/moa-blog-banner.webp",
  "/assets/programs/moa/moyosore.webp",
  "/assets/programs/moa/ronalyn.webp",
  "/assets/programs/moa/shabnam.webp",
  "/assets/programs/moa/untitled-moa.webp",
  "/assets/programs/moa/vanessa.webp",
  "/assets/programs/moa/viqar.webp",
  "/assets/programs/psw/blog-Amrita.webp",
  "/assets/programs/psw/blog-Christine.webp",
  "/assets/programs/psw/blog-protect-ontario.webp",
  "/assets/programs/psw/faculty-Angelina.webp",
  "/assets/programs/psw/faculty-Betiel.webp",
  "/assets/programs/psw/faculty-Carolyn.webp",
  "/assets/programs/psw/faculty-Cheyenne.webp",
  "/assets/programs/psw/faculty-Eleonor.webp",
  "/assets/programs/psw/faculty-Fely-Grace.webp",
  "/assets/programs/psw/faculty-Gloria.webp",
  "/assets/programs/psw/faculty-Harpreet.webp",
  "/assets/programs/psw/faculty-Jacqueline.webp",
  "/assets/programs/psw/faculty-Jenelle.webp",
  "/assets/programs/psw/faculty-Karen.webp",
  "/assets/programs/psw/faculty-Lani.webp",
  "/assets/programs/psw/faculty-Laurie.webp",
  "/assets/programs/psw/faculty-Lindsey.webp",
  "/assets/programs/psw/faculty-Liz.webp",
  "/assets/programs/psw/faculty-Lori.webp",
  "/assets/programs/psw/faculty-Lucie.webp",
  "/assets/programs/psw/faculty-Marcie.webp",
  "/assets/programs/psw/faculty-Melissa.webp",
  "/assets/programs/psw/faculty-Michelle-B.webp",
  "/assets/programs/psw/faculty-Michelle-S.webp",
  "/assets/programs/psw/faculty-Norlyn.webp",
  "/assets/programs/psw/faculty-Rani.webp",
  "/assets/programs/psw/faculty-Vycki.webp",
  "/assets/programs/psw/faculty-Yodeet.webp",
  "/assets/programs/psw/hero-Background-18.webp",
  "/assets/programs/psw/hero-Clarissa-M.webp",
  "/assets/programs/psw/review-Daisy.webp",
  "/assets/programs/psw/review-Mhoonom.webp",
  "/assets/programs/psw/review-Paras.webp",
  "/assets/programs/psw/review-Trisa.webp"
]);
